import { render } from "./CvrCard.vue?vue&type=template&id=0f36484e"
import script from "./CvrCard.vue?vue&type=script&lang=js"
export * from "./CvrCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__